import moment from 'moment'

moment.locale('es')

export const dataLayerV2UniversalPush = (params) => {
  const {
    event, // 'universalEvent'
    eventCategory, // String
    eventAction, // String
    eventLabel // String
  } = params

  let dataLayerObject = {
    event: event || 'universalEvent'
  }

  if (eventCategory) {
    dataLayerObject = {
      ...dataLayerObject,
      eventCategory
    }
  }

  if (eventAction) {
    dataLayerObject = {
      ...dataLayerObject,
      eventAction
    }
  }

  if (eventLabel) {
    dataLayerObject = {
      ...dataLayerObject,
      eventLabel
    }
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(dataLayerObject)
}

export const dataLayerPush = (params) => {
  const {
    event, // 'websiteEvent || onboardingEvent'
    eventAction, // 'click || mouse out || mouse in || input in || input out'
    eventValue, // Number || String
    eventLabel, // String
    eventRoute, // String
    eventLocation, // String
    eventProduct, // 'Crédito de Liquidez || Vivienda || Oficinas y Locales || Terrenos 
    // || Autofinanciamiento || PyME Liquidez || PYME Inmueble || Crédito Puente'
    eventDevice, // 'Desktop || Mobile'
    eventTime, // String
    eventDate, // String
    eventDescription, // String
    eventStatus // String
  } = params

  let dataLayerObject = {
    event: event || 'websiteEvent'
  }
  if (eventAction) {
    dataLayerObject = {
      ...dataLayerObject,
      eventAction
    }
  }
  if (eventValue) {
    dataLayerObject = {
      ...dataLayerObject,
      eventValue
    }
  }
  if (eventLabel) {
    dataLayerObject = {
      ...dataLayerObject,
      eventLabel
    }
  }
  if (eventRoute) {
    dataLayerObject = {
      ...dataLayerObject,
      eventRoute
    }
  } else if (window.gatsbyHref) {
    dataLayerObject = {
      ...dataLayerObject,
      eventRoute: window.gatsbyHref
    }
  }
  if (eventLocation) {
    dataLayerObject = {
      ...dataLayerObject,
      eventLocation
    }
  }
  if (
    eventProduct &&
        typeof eventProduct === 'string' &&
        (eventProduct === 'Crédito de Liquidez' ||
        eventProduct === 'Vivienda' ||
        eventProduct === 'Oficinas y Locales' ||
        eventProduct === 'Terrenos' ||
        eventProduct === 'Autofinanciamiento' ||
        eventProduct === 'PyME Liquidez' ||
        eventProduct === 'PyME Inmuebles' ||
        eventProduct === 'Crédito Puente')
  ) {
    dataLayerObject = {
      ...dataLayerObject,
      eventProduct
    }
  }

  if (
    eventDevice &&
        typeof eventDevice === 'string' &&
        (eventDevice === 'Desktop' ||
        eventDevice === 'Mobile')
  ) {
    dataLayerObject = {
      ...dataLayerObject,
      eventDevice
    }
  } else if (typeof window.isMobile !== 'undefined') {
    dataLayerObject = {
      ...dataLayerObject,
      eventDevice: window.isMobile ? 'Mobile' : 'Desktop'
    }
  }

  dataLayerObject = {
    ...dataLayerObject,
    eventTime: eventTime || moment().format('HH:mm:ss')
  }

  dataLayerObject = {
    ...dataLayerObject,
    eventDate: eventDate || moment().format('DD MMMM YYYY')
  }

  if (eventDescription) {
    dataLayerObject = {
      ...dataLayerObject,
      eventDescription
    }
  }

  if (eventStatus) {
    dataLayerObject = {
      ...dataLayerObject,
      eventStatus
    }
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(dataLayerObject)
}
